import { AxiosInstance } from 'axios';

import { BaseAuthenticatedClient } from '.';
import { BaseDataResponse, BaseResponse } from '../responses';
import { ReservationGuestStornoModel } from '../interfaces';
import { IAuthenticatedRequestHandler, IErrorHandler } from '../abstractions';

export default class ReservationGuestStornoClient extends BaseAuthenticatedClient {
  constructor(authenticatedRequestHandler: IAuthenticatedRequestHandler, errorHandler: IErrorHandler, axiosInstance: AxiosInstance) {
    super(authenticatedRequestHandler, errorHandler, axiosInstance, 'reservationguestrefund');
  }

  public async getAllAsync(id: number): Promise<BaseDataResponse<ReservationGuestStornoModel[]>> {
    return await this.getHttpAsync<BaseDataResponse<ReservationGuestStornoModel[]>>(`${id}`, '');
  }

  public async createAsync(model: ReservationGuestStornoModel): Promise<BaseDataResponse<ReservationGuestStornoModel>> {
    return await this.postHttpAsync<BaseDataResponse<ReservationGuestStornoModel>, ReservationGuestStornoModel>('', model);
  }

  public async updateAsync(model: ReservationGuestStornoModel): Promise<BaseDataResponse<ReservationGuestStornoModel>> {
    return await this.putHttpAsync<BaseDataResponse<ReservationGuestStornoModel>, ReservationGuestStornoModel>(`${model.id}`, model);
  }

  public async deleteAsync(id: number): Promise<BaseResponse> {
    return await this.deleteHttpAsync<BaseResponse>(`${id}`);
  }

  public async getInfoAsync(model: ReservationGuestStornoModel): Promise<BaseDataResponse<string>> {
    return await this.postHttpAsync<BaseDataResponse<string>, ReservationGuestStornoModel>('info', model);
  }
}
